import React from 'react';
import PatientList from '../../components/doctors/PatientManagement/PatientList';


/**
 * Patient management page
 * A page that displays the doctor's patients with options to view and manage them
 */
const PatientsPage = () => {
  return (
      
        <PatientList />

  );
};

export default PatientsPage;